import React from 'react'
import { technologies } from "./data";

function Technologies() {
  return (
    <div className="skills_content">
        <h3 className="skill_title">Technologies</h3>
        <div className="skills_group grid">

        {technologies.map((tech)=>(
        <div key={tech.id} className="skills_data">
            {tech.icon}
            <h3 className="skills_name">{tech.name}</h3>
        </div>
        ))}

        {/* <div className="skills_data">
            <i className='bx bxl-html5' ></i>
            <h3 className="skills_name">HTML</h3>
        </div>

        <div className="skills_data">
            <i className='bx bxl-css3' ></i>
            <h3 className="skills_name">CSS</h3>
        </div>  

        <div className="skills_data">
            <i className='bx bxl-javascript skills_icon'></i>
            <h3 className="skills_name">JavaScript</h3>
        </div>  

        <div className="skills_data">
            <i className='bx bxl-tailwind-css '></i>
            <h3 className="skills_name">Tailwind</h3>
        </div>  

        <div className="skills_data">
            <i className='bx bxl-bootstrap '></i>
            <h3 className="skills_name">Bootstrap</h3>
        </div>  

        <div className="skills_data">
            <i className='bx bxl-react ' ></i>
            <h3 className="skills_name">React js</h3>
        </div>

        <div className="skills_data">
            <i className='bx bxl-react' ></i>
            <h3 className="skills_name">React Router</h3>
        </div>

        <div className="skills_data">
            <i className='bx bxl-redux' ></i>
            <h3 className="skills_name">Redux & Toolkit</h3>
        </div> 

        <div className="skills_data">
            <i className="uil uil-cloud-database-tree"></i>
            <h3 className="skills_name">Api "fatch,axios"</h3>
        </div>   */}
        </div>
    </div>
  )
}

export default Technologies